import dayjs from 'dayjs';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { toDenominatorDateFormat } from 'src/shared/lib/date';
import { DatePicker } from 'src/shared/ui/inputs/DatePicker';
import s from './DeadlineField.module.scss';
import { getYearString } from '../_lib/getYearString';

type Props = Omit<GeneratedField, 'validate' | 'measureUnits'>;

export const DeadlineField: React.FC<Props> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
	} = props;

	// * Form
	const { setValue, control } = useFormContext();

	const existence = useWatch({
		name: `${namePrefix}${propertyName}.existence.value`,
	});

	const name = `${namePrefix}${propertyName}.${internalName}`;
	const VALUE_NAME = `${name}.value`;

	const deadlineValidation = (value: string | null) => {
		if (value) {
			const year = getYearString(value);
			if (year.length < 4 || year.length > 4 || +year < 1900 || +year > 2100) return 'Year must be between 1900 and 2100';
		}
	};

	const textFieldOnChangeHandler = (date: string | null) => {
		if (date === null) {
			setValue(VALUE_NAME, null);
		} else {
			setValue(VALUE_NAME, date);
		}
	};

	// Target Fields only ...
	const disableBasedOnExistence = existence === null || existence === 'false';
	// ...

	// * Render
	return (
		<Controller
			name={`${name}.value`}
			control={control}
			rules={{ validate: deadlineValidation }}
			render={({ field, fieldState }) => (
				<div className={s.fieldWrapper}>
					<div className={s.additionalTextLeft}>Deadline:</div>

					<DatePicker
						value={field.value ? dayjs(field.value) : undefined}
						onChange={(date) => textFieldOnChangeHandler(date === null ? null : toDenominatorDateFormat(date.startOf('year').toDate()))}
						picker="year"
						disabled={disableBasedOnExistence}
						error={fieldState.error?.message}
						size="middle"
					/>
				</div>
			)}
		/>
	);
};
